import { DialogContentProps } from '@material-ui/core';

export const DIALOG_SIZES = {
  small: 628 as const,
  medium: 800 as const,
} as const;

export type DialogSize = typeof DIALOG_SIZES[keyof typeof DIALOG_SIZES] | number;

export interface DialogProps {
  scroll?: 'body' | 'paper';
  open?: boolean;
  className?: string;
  closeHandler?: () => void;
  showCloseIcon?: boolean;
  disableBackdropClick?: boolean;
  fullWidth?: boolean;
  dialogContentProps?: DialogContentProps;
  ariaLabelledBy?: string;
  ariaDescribedBy?: string;
  bodyScrollLockDisabled?: boolean;
  disableFocusTrap?: boolean;
  size?: DialogSize;
  children?: React.ReactNode;
  contentRef?: React.RefCallback<HTMLElement>;
  footer?: React.ReactNode;
  showTopBorder?: boolean;
  showBottomBorder?: boolean;
  hasScroll?: boolean;
  paperInnerClassName?: string;
  contentWrapperClassName?: string;
}
